export default "__VITE_ASSET__DMmGEVeQ__"